
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UiButton from "@/components/button/ui-button.vue";
  import ModalWithTrigger from "@/components/modal/ModalWithTrigger.vue";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
  import AddPaymentCardForm from "@/components/payment/AddPaymentCardForm.vue";
  import lambdaRequest from "@/helpers/lambdaRequest";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      AddPaymentCardForm,
      UiButton,
      ModalWithTrigger,
      ModalSectionsDivider,
    },
  })
  export default class AddPaymentCardModal extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, default: "Add" }) readonly actionButtonText!: string;
    @Prop({ type: Boolean, default: false }) readonly asDefaultCard!: boolean;

    processing: boolean = false;
    errorMessage: string = "";

    async addCard(card: { token: string }, closeModal: Function): Promise<void> {
      this.processing = true;
      const { token } = card;

      try {
        await lambdaRequest({
          lambdaName: "addPaymentCard",
          requestData: {
            token,
          },
        });

        this.$emit("cardAdded");
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("The credit card has been added"));

        closeModal();
      } catch (error) {
        this.errorMessage = error.message;
      }finally {
        this.processing = false;
      }

    }
  }
